import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    // minWidth: 275,
    width: 400,
    height: 220,
  },
  cardDiv: {
    display: "flex",
    flexDirection: "row",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  buttonStyle: {
    marginLeft: 10,
  },
});

function CardComponent(props) {
  const classes = useStyles();

  return (
    <div className={classes.cardDiv}>
      <Card className={classes.root}>
        <CardContent>
          <Typography variant="h5" component="h2">
            {props.title}
          </Typography>
          <hr></hr>
          <Typography className={classes.pos} color="textSecondary">
            {props.details}
          </Typography>

          {/* <Typography variant="body2" component="p">
            <br />
          </Typography> */}
        </CardContent>
        <CardActions>
          {/* <Button size="small">Learn More</Button> */}
          <Button
            className={classes.buttonStyle}
            variant="outlined"
            color="primary">
            Learn More
          </Button>
        </CardActions>
      </Card>
    </div>
  );
}

export default CardComponent;
